
import React, { useState, useEffect, useRef } from 'react';
// import '../App.css'
import "../App.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grain1 from '../assets/images/Horizontal.png'
import Grain2 from '../assets/images/Vertical_Sequence.png'
import Grain3 from '../assets/images/Vertical.png'
import Camera from '../assets/images/icon-camera-angle.jpg'
import Layout from '../assets/images/icon-layout.jpg'
import Email from '../assets/images/icon-email.jpg'
import Print from '../assets/images/icon-print_sq1000px.jpg'
import FaEys from '../assets/images/icon-visible.jpg'
import FaEysSlash from '../assets/images/icon-non-visible.jpg'
import { faTimes } from "@fortawesome/free-solid-svg-icons"
import Grain4 from '../assets/images/Horizontal_Sequence.png'
import { MdOutlineMailOutline } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoMdPrint } from 'react-icons/io';
import { HiPhoto } from 'react-icons/hi2';
import ApplyAll from '../assets/images/icon-apply-all.png'
import { useLocation, useSearchParams } from 'react-router-dom';
import { sanitizeRichText } from '../utils/richText';

// The layout picker was drawn for three thumbnails across; keeping that as the
// floor stops a short list from blowing each tile up to fill the row.
const LAYOUT_TILES_PER_ROW = 3;

const Nav = ({ onHideGrainChange, setlayoutKey, layoutKey, finalArray, setIsPanelOpen, categoryNames, fetchDataRef, selectedAngle, setSelectedAngle, emailOnPrint, VisualizerCategory, setEmailOnPrint, isLoading, setEmail, setEmailError, setNameError, setComment, showEmailPopup, setName, setShowEmailPopup, onImageClick, defaultGrain, setSelectedRegion, hoveredCategoryId, generatePDF, setClickedData, clickedData, setIsLoading, setHoveredCategoryId, email, name, handleEmailChange, handleNameChange, handleSendEmailForPrint, emailError, nameError, comment, handleCommentChange, layoutangle }) => {
  const [popupData, setPopupData] = useState(null);
  const [selectedMasterCategory, setSelectedMasterCategory] = useState(null);
  const [selectedChildCategory, setSelectedChildCategory] = useState(null);
  const [showChildCategory, setShowChildCategory] = useState(false);
  const [expandedStaticCategory, setExpandedStaticCategory] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedGrain, setSelectedGrain] = useState(defaultGrain);
  const [clickedImages, setClickedImages] = useState([]);
  const [collections, setCollections] = useState([]);
  const [selectedImagesPerCategory, setSelectedImagesPerCategory] = useState({});
  const [Defaultname, setDefaultname] = useState('');
  const [selectedImagesPerStaticCategory, setSelectedImagesPerStaticCategory] = useState(defaultGrain);
  const [selectedImage, setSelectedImage] = useState({
    name: "",
    category: "",
    categoryId: null,
  });
  const [isCameraDropdownOpen, setIsCameraDropdownOpen] = useState(false);
  const [selectedView, setSelectedView] = useState(layoutangle);
  const [printemail, setprintemail] = useState('');
  const [printEmailError, setprintEmailError] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [showLayout, setShowLayout] = useState(false);
  const prevLayoutKeyRef = useRef(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [expandedagain, setExpandedagain] = useState(false);
  const [selectedsubCate, setSelectedsubCate] = useState('');
  const [selectedExpanded, setSelectedExpanded] = useState('');
  const [hideGrain, setHideGrain] = useState(false);
  const [hideGrainByLayout, setHideGrainByLayout] = useState({});
  const [sortedCollection, setSortedCollection] = useState([]);
  const [isApplyAllInProgress, setIsApplyAllInProgress] = useState(false);
  const applyAllLockRef = useRef(false);
  const [searchParams] = useSearchParams();
  const urlKey = searchParams.get('key');

  // Which categories this layout actually has assets for, accumulated across
  // every camera angle loaded so far, keyed by layout.
  //
  // One angle's response cannot tell the two "empty" cases apart. Tall Cabinets
  // comes back with GroupAssetsColor: [] on the kitchen's V3 but has 722 colours
  // on V1/V2 — it belongs to the layout and is merely out of shot, so its
  // selection must still show. The bathroom's Base/Wall/Island are empty in
  // EVERY angle — they aren't part of that layout at all and must stay "N/A".
  // Both look identical in a single response, and default_display_menu doesn't
  // separate them either (the bathroom's Base Cabinets is flagged 1, same as the
  // kitchen's Tall). Angle V1 is always fetched first, so by the time the user
  // can click anything this holds the layout's real category set.
  const layoutCategoriesRef = useRef({});

  // Which layout the data currently in VisualizerCategory actually describes.
  // layoutKey flips the instant a layout is clicked, but the fetch for it takes
  // seconds — until it lands, VisualizerCategory still holds the PREVIOUS
  // layout's GroupAssets. Keying anything off layoutKey alone during that window
  // attributes the old layout's categories to the new layout (the kitchen's
  // Base/Wall/Island getting recorded against the bathroom, so they showed a
  // colour instead of N/A). Layout.key comes from the response itself, so it is
  // the only trustworthy answer to "whose data is this?".
  const loadedLayoutKey = VisualizerCategory?.Layout?.key;
  const dataMatchesLayout = !!loadedLayoutKey && loadedLayoutKey === layoutKey;

  useEffect(() => {
    const groups = VisualizerCategory?.GroupAssets;
    if (!groups || !dataMatchesLayout) return;

    const seen = layoutCategoriesRef.current[layoutKey] || new Set();
    groups.forEach((g) => {
      if (g.GroupAssetsColor?.length > 0) seen.add(g.name);
    });
    layoutCategoriesRef.current[layoutKey] = seen;
  }, [VisualizerCategory, layoutKey, dataMatchesLayout]);

  // Collections carry an internal `name` ("Shinnoki") and a customer-facing
  // `label` ("SHINNOKI by DECOSPAN"). Everything matches on name — clickedData,
  // selectedImagesPerCategory, the asset lookups — so the name stays the key and
  // this is only for DISPLAY. Falls back to the name when no label is set.
  const collectionLabel = (name) => {
    if (!name) return { text: name, fromLabel: false };
    const match = (VisualizerCategory?.Collections || []).find(
      (c) => c.name?.trim().toLowerCase() === name.trim().toLowerCase()
    );
    return match?.label
      ? { text: match.label, fromLabel: true }
      : { text: name, fromLabel: false };
  };

  // A label is shown exactly as it was typed in admin — that is what the field
  // is for. It used to go through collectionLabelMarkup, which split "X by Y"
  // and uppercased both halves, so admin's "Shinnoki by DECOSPAN" reached the
  // customer as "SHINNOKI by DECOSPAN" and "TOUCH by AGT" lost its own casing.
  // Sanitised rather than raw because the value is stored HTML — the label
  // editor can put sub/sup/bold in it — and it goes through innerHTML.
  // `styled` is false only when there is no label and the collection's own name
  // stands in; those keep the blanket uppercase they have always had.
  const collectionLabelHtml = (name) => {
    const { text, fromLabel } = collectionLabel(name);
    return { html: sanitizeRichText(text), styled: fromLabel };
  };

  // True when the category has assets in the current angle, or had them in any
  // angle already loaded for THIS layout. False means "absent from the whole
  // layout" — those keep showing N/A and Apply-All must not label them.
  // While a switch is in flight the current data belongs to another layout, so
  // nothing about it can be trusted: report false and show N/A until it lands.
  const belongsToLayout = (group) => {
    if (!dataMatchesLayout) return false;
    return (
      group?.GroupAssetsColor?.length > 0 ||
      layoutCategoriesRef.current[layoutKey]?.has(group?.name) === true
    );
  };

  // Seeding a freshly opened layout's selections from a layout the user already
  // configured used to happen inline in the JSX below, which called setState
  // during render — that is what produced React's "Cannot update a component
  // (`Nav`) while rendering a different component (`Home`)" warning. An effect is
  // equivalent and legal. Categories the layout has no assets for are skipped, so
  // they show N/A instead of inheriting an unrelated layout's colour (the
  // bathroom's Base Cabinets must not pick up the kitchen's).
  useEffect(() => {
    const groups = VisualizerCategory?.GroupAssets;
    if (!groups || !layoutKey) return;

    setSelectedImagesPerCategory((prev) => {
      const current = prev?.[layoutKey] || {};
      const additions = {};

      groups.forEach((group) => {
        if (current[group.name]) return;
        if (!belongsToLayout(group)) return;

        const inherited = Object.entries(prev || {}).find(
          ([key, byCategory]) => key !== layoutKey && byCategory?.[group.name]
        );
        if (inherited) additions[group.name] = inherited[1][group.name];
      });

      if (Object.keys(additions).length === 0) return prev;
      return { ...prev, [layoutKey]: { ...current, ...additions } };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [VisualizerCategory, layoutKey]);

  useEffect(() => {
    const allValues = Object.values(hideGrainByLayout);
    const anyTrue = allValues.some(val => val === true);
    const allFalse = allValues.every(val => val === false);

    const newHideGrain = anyTrue ? true : allFalse ? false : false;

    // update only if different
    setHideGrain(prev => (prev !== newHideGrain ? newHideGrain : prev));

    setHideGrainByLayout(prev => {
      const updated = { ...prev };
      let hasChanged = false;

      Object.keys(updated).forEach(key => {
        if (updated[key] !== newHideGrain) {
          updated[key] = newHideGrain;
          hasChanged = true;
        }
      });

      return hasChanged ? updated : prev;
    });
  }, [hideGrainByLayout]);



  useEffect(() => {

    function handleClickOutside(event) {
      if (!event.target.closest(".expanded-view")) {
        setExpandedagain(false);
        setExpandedCategory(null);
      }
    }

    if (expandedagain) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [expandedagain]);
  useEffect(() => {


    if (hoveredCategoryId) {
      const transformedHoveredCategoryId = hoveredCategoryId.replace(/_/g, ' ');

      const matchingCategory = VisualizerCategory.GroupAssets.find((cat) => {

        return cat.name === transformedHoveredCategoryId;
      });

      if (matchingCategory) {
        handleCategoryClick(matchingCategory);
      }
    }
  }, [hoveredCategoryId]);
  const staticCategories = [
    { id: 89, name: 'Style & Grain', ChildCategory: ['Vertical sequence'] },
  ];

  useEffect(() => {
    if (defaultGrain !== null) {
      setSelectedGrain(defaultGrain);
      setSelectedImagesPerStaticCategory(defaultGrain);
    }

  }, [defaultGrain]);

  useEffect(() => {
    if (VisualizerCategory.GroupAssets && VisualizerCategory.GroupAssets.length > 0) {
      const firstMasterCategory = VisualizerCategory.GroupAssets[0];   
      setSelectedMasterCategory(firstMasterCategory);

      const firstChildCategory = firstMasterCategory.GroupAssetsColor?.[0];   
      setSelectedChildCategory(firstChildCategory);
      setCollections(firstMasterCategory.Collections);
    }
  }, []);


  useEffect(() => {
    if (VisualizerCategory && VisualizerCategory.length > 0) {

    }
    if (selectedMasterCategory && VisualizerCategory && Array.isArray(VisualizerCategory.GroupAssets)) {

      const matchedCategory = VisualizerCategory.GroupAssets.find(
        (cat) => cat.id === selectedMasterCategory.id
      );

      if (matchedCategory) {

        const matchedColorObj = matchedCategory.GroupAssetsColor?.[0];

        const defaultColorName = matchedColorObj?.AssetColor?.name || '';
        const defaultCollectionName = matchedColorObj?.AssetCollection?.name || '';

        setDefaultname(defaultColorName);

      }
    }
  }, [selectedMasterCategory, VisualizerCategory]);
  useEffect(() => {
    if (
      VisualizerCategory?.Collections &&
      Array.isArray(VisualizerCategory.Collections)
    ) {
      const sorted = [...VisualizerCategory.Collections].sort(
        (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
      );

      setSortedCollection(sorted);
    }
  }, [VisualizerCategory]);


  //helper code
  const getApiColorId = async (colorId) => {


    if (!colorId || !sortedCollection || sortedCollection.length === 0) {
      return null;
    }

    let matchedColor = null;
    let matchedCollection = null;

    for (const collection of sortedCollection) {
      const found = collection.CollectionColor?.find(
        (cc) => cc.id?.toString() === colorId?.toString()
      );
      if (found) {
        matchedColor = found;
        matchedCollection = collection;
        break;
      }
    }

    if (!matchedColor) {
      return null;
    }

    const colorCode = matchedColor.color_code;
    const collectionId = matchedCollection.api_collection_id;


    try {
      const response = await fetch(
        `https://customcabinetry-middleware.herokuapp.com/api/getcolorandgrain`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            collection_id: collectionId,
          }),
        }
      );
      const apiData = await response.json();
      const colors = apiData?.data?.colors || apiData?.colors || apiData?.Colors || [];

      const apiMatched = Array.isArray(colors)
        ? colors.find((c) => {
          return c.color_code?.toString() === colorCode?.toString();
        })
        : null;



      return apiMatched?.id ?? null;

    } catch (err) {
      console.error('Error fetching color and grain API:', err);
      return null;
    }
  };


  const printLayout = () => {
    setName('')
    setComment('')
    setEmail('')
    setEmailError('')
    setNameError('')
    setprintemail('');
    setprintEmailError('');
    setSelectedRegion(null)
    setEmailOnPrint(true);
    setShowLayout(null);
    setShowEmailPopup(null)
    setShowChildCategory(null)
    setPopupData(null)
    setSelectedCategoryId(null)
    setIsCameraDropdownOpen(null)
    setShowChildCategory(false)

    // window.print();
  };

  const handleGrainChange = (grainType, grainName) => {
    setIsPanelOpen(false);
    setIsLoading(true);
    setSelectedGrain(grainType);

    const defaultGrainTypeResult = {
      parentName: "Style & Grain",
      categoryName: "Slab",
      id: grainType,
      imageName: grainName,
    };


    setClickedData(prevClickedData => {
      const updatedLayouts = { ...prevClickedData };

      Object.keys(updatedLayouts).forEach((layoutKey) => {
        const layoutArray = updatedLayouts[layoutKey] || [];

        const itemIndex = layoutArray.findIndex(
          item => item.parentName === defaultGrainTypeResult.parentName
        );

        if (itemIndex !== -1) {
          layoutArray[itemIndex] = {
            ...layoutArray[itemIndex],
            imageName: defaultGrainTypeResult.imageName,
          };
        } else {
          layoutArray.push(defaultGrainTypeResult);
        }

        updatedLayouts[layoutKey] = layoutArray;
      });

      return updatedLayouts;
    });


    setShowLayout(false);
  };



  const closePopup = () => {
    setPopupData(null);
    setShowLayout(null)
    setEmailOnPrint(null);
    setHoveredCategoryId(null);
    setShowChildCategory(null)
  };


  const handleStyleChange = async (style) => {
    setIsPanelOpen(false);
    if (style.id === layoutKey) {
      setShowLayout(false);
      return;
    }

    setIsLoading(true);
    setShowLayout(true);
    await new Promise((resolve) => requestAnimationFrame(resolve));

    prevLayoutKeyRef.current = layoutKey;

    setlayoutKey(style.id);
    setSelectedAngle(layoutangle);
    setSelectedView(layoutangle);

    // isLoading is intentionally left on here — Home's fetchData()/
    // handleImageLoad() chain (triggered by the layoutKey change) turns it
    // off once the new layout's data and images actually finish loading.
    // Forcing it false on this fixed timer made the spinner disappear before
    // the real fetch completed, then reappear once the real load started —
    // that's the "loader vanishes then comes back" gap.
    setTimeout(() => {
      setShowLayout(false);
    }, 50);
  };





  const handleGrainStyleChange = () => { }

  const handleToggleChildCategory = () => {
    setShowChildCategory((prevState) => !prevState);
    setExpanded(false);
    setShowLayout(null)
    setIsCameraDropdownOpen(null)
    setShowEmailPopup(null)
    setEmailOnPrint(null)


  };


  const handleLayout = () => {
    setShowLayout(true);
    setShowEmailPopup(null)
    setEmailOnPrint(null)
    setShowChildCategory(null)
    setPopupData(null)
    setSelectedCategoryId(null)
    setIsCameraDropdownOpen(null)


  };

  const handleCategoryClick = (category) => {
    if (!category.GroupAssetsColor || category.GroupAssetsColor.length === 0) return;
    setIsPanelOpen(false);
    setEmailOnPrint(null);
    setShowEmailPopup(null);
    setSelectedsubCate('');
    setIsCameraDropdownOpen(null);
    setShowLayout(null);

    setSelectedCategoryId(category.id);
    setExpanded(false);
    setSelectedMasterCategory(category); // use category directly
    setSelectedChildCategory(category.ChildCategory?.[0] || null);
    setShowChildCategory(true);

    // Access GroupAssetsColor safely
    const groupAssetsColor = category.GroupAssetsColor || [];


    // Get default color name from matched default settings
    const defaultSettings = JSON.parse(category.Layout?.default_settings || '[]');
    const matchedDefault = defaultSettings.find(setting => {
      const groupIds = setting.group_id?.split(',') || [];
      return groupIds.includes(String(category.id));
    });

    let defaultColorName = '';
    let defaultCollectionName = '';

    if (matchedDefault && groupAssetsColor.length > 0) {
      const matchedColor = groupAssetsColor.find(
        colorObj => String(colorObj.AssetColor?.id) === String(matchedDefault.colro_id)
      );

      if (matchedColor) {
        defaultColorName = matchedColor.AssetColor?.name || '';
        defaultCollectionName = matchedColor.AssetCollection?.name || '';
      }
    }

    setCollections(VisualizerCategory.Collections)

    // Update popup data with new structure
    setPopupData({
      defaultColor: defaultColorName,
      defaultCollection: defaultCollectionName,
      category: category,
      type: 'dynamic',
      parentName: category.name
    });
  };

  const checkHideGrain = (selectedGroupsObj, layoutKey) => {
    // "Cabinets" categories vary per layout (Base/Wall/Island/Tall for a kitchen,
    // Tall/Vanity for another) — derive the required parents from the API
    // response instead of a fixed name list.
    const normalizedFullData = (VisualizerCategory.GroupAssets || []).filter(
      g => g.category === "Cabinets"
    );

    // Only the cabinets this layout actually has can be required here.
    // Counting every group with category === "Cabinets" made this permanently
    // false: the kitchen carries Vanity Cabinets with 0 assets and the bathroom
    // carries Base/Wall/Island with 0, so the "all parents present" check bailed
    // out before the grain comparison ever ran — the Grain section never hid,
    // even with every cabinet set to a NoGrain colour.
    // Appliances is excluded too: the API files it under category "Cabinets",
    // but it is a finish (Stainless Steel / Panel Ready), not a door, so its
    // grain says nothing about whether a grain direction is selectable.
    const REQUIRED_PARENTS = normalizedFullData
      .filter(
        g =>
          belongsToLayout(g) &&
          g.name?.trim().toLowerCase() !== "appliances"
      )
      .map(g => g.name);

    const layoutData = selectedGroupsObj[layoutKey];
    if (!layoutData || layoutData.length === 0 || REQUIRED_PARENTS.length === 0) {
      return false;
    }

    const selectedItems = layoutData.filter(i => i.id !== undefined);

    const parentMap = {};
    selectedItems.forEach(item => {
      const parents = Array.isArray(item.parentName)
        ? item.parentName
        : [item.parentName];

      parents.forEach(p => {
        if (!parentMap[p]) parentMap[p] = [];
        parentMap[p].push(item);
      });
    });

    // Check all required parents exist
    for (let parent of REQUIRED_PARENTS) {
      if (!parentMap[parent] || parentMap[parent].length === 0) {
        return false;
      }
    }

    // Check grain for each parent
    for (let parent of REQUIRED_PARENTS) {
      const selected = parentMap[parent][0];
      const fullItem = normalizedFullData.find(f => f.name === parent);

      if (!fullItem) return false;

      const group = fullItem.GroupAssetsColor?.find(
        g =>
          g.AssetCollection?.name === selected.categoryName &&
          g.name === selected.imageName
      );

      if (!group || group.grain !== "NoGrain") return false;
    }

    return true;
  };

  // hideGrain is derived state: it depends only on clickedData + this layout.
  // It used to be computed inside the setClickedData updaters in
  // handleDefaultClick / handleImageClick, which is what produced React's
  // "Cannot update a component (`Nav`) while rendering a different component
  // (`Home`)" warning: setClickedData is HOME's state setter, React invokes an
  // updater function during the owner's render pass, so calling Nav's own
  // setHideGrain / setHideGrainByLayout from in there is a setState during
  // Home's render. clickedData arrives here as a prop, so deriving it in an
  // effect is equivalent and legal.
  useEffect(() => {
    if (!layoutKey || !clickedData) return;

    const shouldHide = checkHideGrain(clickedData, layoutKey);
    setHideGrain(shouldHide);
    // PricePanel needs the same answer to drop its "Style & Grain" row, and it
    // cannot work it out itself — finalArray entries carry no grain field. Hand
    // it up to Home, which owns both components.
    onHideGrainChange?.(shouldHide);
    setHideGrainByLayout((prev) => {
      const next = { ...prev, [layoutKey]: shouldHide };
      Object.keys(next).forEach((key) => {
        next[key] = shouldHide;
      });
      const unchanged =
        Object.keys(next).length === Object.keys(prev).length &&
        Object.keys(next).every((key) => prev[key] === next[key]);
      return unchanged ? prev : next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedData, layoutKey]);

  // The API files Appliances under category "Cabinets", but it is a finish
  // (Stainless Steel / Panel Ready) with its own two options — it has no door
  // collection, so a cabinet collection like "AGT" means nothing on it.
  // Apply-To-All-Cabinets must leave it exactly as the user set it.
  const isAppliances = (name) => name?.trim().toLowerCase() === "appliances";

  const requiredCategories = (VisualizerCategory.GroupAssets || [])
  .filter(g => g.category === "Cabinets" && g.GroupAssetsColor?.length > 0 && !isAppliances(g.name))
  .map(g => g.name);

  // Every cabinet category, whether or not this layout has assets for it.
  // Apply-All records the applied colour against all of them so the selection
  // travels between layouts (apply in the bathroom, the kitchen's Base/Wall/
  // Island carry it too). Showing it is a separate decision: the tile renders
  // through belongsToLayout, so a category absent from this whole layout still
  // displays N/A even though its value is stored here. Storage vs. display —
  // don't collapse the two.
  const allCabinetCategories = (VisualizerCategory.GroupAssets || [])
    .filter(g => g.category === "Cabinets" && !isAppliances(g.name))
    .map(g => g.name);

  const labelCategories = allCabinetCategories;

  const handleDefaultClick = async (
    parentName,
    assetArray,
    groupAssets,
    categoryName
  ) => {
    if (applyAllLockRef.current) return;
    applyAllLockRef.current = true;
    setIsApplyAllInProgress(true);

    try {
      const currentLayoutKey = layoutKey;
      const allParents = categoryNames;

      const matchedImages = groupAssets.flatMap((category) => {
        const colors = category.GroupAssetsColor || [];
        return assetArray.flatMap((asset) =>
          colors
            .filter((ga) => ga.name === asset.path)
            .map((ga) => {
              if (ga.grain === "NoGrain" || ga.grain === selectedGrain) {
                return {
                  path: ga.asset_image,
                  category: category.name,
                  fullObj: ga
                };
              }
              return null;
            })
            .filter(Boolean)
        );
      });

      const ids = matchedImages.map((m) => m.fullObj.id);
      const names = matchedImages.map((m) => m.fullObj.name);
      const parentNames = [...new Set(matchedImages.map((m) => m.category))];

      const defaultCategoryName = matchedImages[0]?.fullObj?.categoryName || categoryName;
      const defaultImageName = matchedImages[0]?.fullObj?.name || names[0];

      // ✅ Saare color_ids ek saath resolve karo (parallel)
      const resolvedColorIds = await Promise.all(
        matchedImages.map((img) => getApiColorId(img.fullObj?.color_id))
      );

      const newClickedData = matchedImages.map((img, idx) => ({
        parentName: img.category,
        categoryName,
        id: img.fullObj.id,
        color_id: resolvedColorIds[idx] ?? img.fullObj?.color_id,
        imageName: img.fullObj.name,
      }));

      // Cabinet categories this layout has no assets for still need the applied
      // colour RECORDED, even though their tile shows N/A here — the value has to
      // travel with the user (apply Cassis in the bathroom, open the kitchen, its
      // Base/Wall/Island are Cassis too). id/color_id stay null on purpose: this
      // layout has no asset of its own to point at, so fetchData resolves the real
      // one by name in whichever layout the category actually exists.
      const unmatchedCabinets = allCabinetCategories
        .filter((name) => !newClickedData.some((d) => d.parentName === name))
        .map((name) => ({
          parentName: name,
          categoryName,
          id: null,
          color_id: null,
          imageName: defaultImageName,
        }));

      const propagatedClickedData = [...newClickedData, ...unmatchedCabinets];

      setClickedData((prev) => {
        const updated = { ...prev };

        if (!updated[currentLayoutKey]) {
          const initParents = [...new Set([...allParents, ...requiredCategories])]
            .filter((p) => !isAppliances(p));
          updated[currentLayoutKey] = initParents.map((p) => ({
            parentName: p,
            categoryName: defaultCategoryName,
            id: null,
            color_id: null,
            imageName: defaultImageName,
          }));
        }

        propagatedClickedData.forEach((dataObj) => {
          const existing = updated[currentLayoutKey].findIndex(
            (d) => d.parentName === dataObj.parentName
          );
          if (existing !== -1) {
            updated[currentLayoutKey][existing] = dataObj;
          } else {
            updated[currentLayoutKey].push(dataObj);
          }
        });

        requiredCategories.forEach((reqCat) => {
          const exists = updated[currentLayoutKey].some(
            (d) => d.parentName === reqCat
          );
          if (!exists) {
            updated[currentLayoutKey].push({
              parentName: reqCat,
              categoryName: defaultCategoryName,
              id: null,
              color_id: null,
              imageName: defaultImageName,
            });
          }
        });

        Object.keys(updated).forEach((key) => {
          if (key === currentLayoutKey) return;

          if (!updated[key]) {
            const initParents = [...new Set([...allParents, ...requiredCategories])]
            .filter((p) => !isAppliances(p));
            updated[key] = initParents.map((p) => ({
              parentName: p,
              categoryName: defaultCategoryName,
              id: null,
              color_id: null,
              imageName: defaultImageName,
            }));
          }

          propagatedClickedData.forEach((dataObj) => {
            const idx = updated[key].findIndex(
              (d) => d.parentName === dataObj.parentName
            );
            if (idx !== -1) {
              updated[key][idx] = dataObj;
            } else {
              updated[key].push(dataObj);
            }
          });
        });

        // hideGrain is derived from clickedData in an effect now — see the
        // comment on that effect. It must not be set from inside this updater:
        // setClickedData belongs to Home, and React runs an updater during the
        // owner's render pass, so touching Nav's state here is a setState during
        // Home's render.
        return updated;
      });

      const onlyImages = matchedImages.map((m) => ({
        path: m.path,
        category: m.category,
      }));

      // ✅ color_id bhi pass karo newClickedImage mein
      const newClickedImage = {
        name: names,
        category: categoryName,
        categoryId: ids,
        color_id: resolvedColorIds[0] ?? null,
        image: onlyImages,
        parentName: parentNames,
      };

      setClickedImages((prev) => [
        ...prev.filter((img) => img.category !== categoryName),
        newClickedImage,
      ]);

      setSelectedImagesPerCategory((prevState) => {
        const updatedState = { ...prevState };
        if (!updatedState[currentLayoutKey]) updatedState[currentLayoutKey] = {};

        // labelCategories, not requiredCategories: a cabinet category the current
        // angle has no assets for (Tall Cabinets on V3) still needs its tile label
        // updated, and the firstMatch === null branch below already produces the
        // right value for it — the applied colour name and collection.
        labelCategories.forEach((pName) => {
          const imagesForParent = matchedImages
            .filter((m) => m.category === pName)
            .map((m) => ({ path: m.path, category: m.category }));

          const firstMatchIdx = matchedImages.findIndex((m) => m.category === pName);
          const firstMatch = firstMatchIdx !== -1 ? matchedImages[firstMatchIdx] : null;

          // ✅ color_id bhi include karo
          const valueObj = firstMatch
            ? {
              name: firstMatch.fullObj.name,
              category: categoryName,
              categoryId: firstMatch.fullObj.id,
              color_id: resolvedColorIds[firstMatchIdx] ?? firstMatch.fullObj?.color_id,
              image: imagesForParent,
            }
            : {
              name: defaultImageName,
              category: categoryName,
              categoryId: null,
              color_id: null,
              image: [],
            };

          updatedState[currentLayoutKey][pName] = valueObj;

          Object.keys(updatedState).forEach((key) => {
            if (key === currentLayoutKey) return;
            if (!updatedState[key]) return;
            updatedState[key][pName] = valueObj;
          });
        });

        return updatedState;
      });

      setSelectedChildCategory({
        names,
        category: categoryName,
        ids,
        parentName: parentNames,
      });
      setSelectedImage({
        names,
        category: categoryName,
        ids,
      });

      if (matchedImages.length > 0) {
        await Promise.resolve(onImageClick(matchedImages, parentNames, selectedAngle, ""));
      }
    } finally {
      requestAnimationFrame(() => {
        applyAllLockRef.current = false;
        setIsApplyAllInProgress(false);
      });
    }
  };



  const handleImageClick = async (
    assetImageName,
    asset,
    categoryName,
    imageNameArray = [],
    parentName = '',
    e,
    demo = []
  ) => {
    const popupCategoryId = popupData?.category?.id;
    const demoValid = Array.isArray(demo) && popupCategoryId !== undefined;

    if (expandedCategory || !demoValid || !demo[popupCategoryId - 1]) {
      setIsLoading(true);
    }

    setSelectedsubCate(categoryName);
    const currentLayoutKey = layoutKey;

    const matchedImages = imageNameArray.flatMap((img) => {
      if (!asset?.GroupAssetsColor) return [];

      return asset.GroupAssetsColor
        .filter((ga) => ga.name === img.path)
        .map((ga) => {
          if (ga.grain === 'NoGrain') return { path: ga.asset_image, category: img.category };
          if (ga.grain === selectedGrain) return { path: ga.asset_image, category: img.category };
          return null;
        })
        .filter(Boolean);
    });



    if (expandedCategory || !demoValid || !demo[popupCategoryId - 1]) {
      setHoveredCategoryId(null);

      // ✅ await lagao
      const resolvedApiColorId = await getApiColorId(assetImageName?.color_id);


      const newClickedData = {
        parentName,
        categoryName,
        id: assetImageName?.id,
        color_id: resolvedApiColorId,
        imageName: assetImageName?.name,
      };

      setClickedData((prevData) => {
        const updatedData = { ...prevData };
        if (!updatedData[currentLayoutKey]) updatedData[currentLayoutKey] = [];

        const existingIndex = updatedData[currentLayoutKey].findIndex(
          (data) => data.parentName === parentName
        );

        if (existingIndex !== -1) {
          updatedData[currentLayoutKey][existingIndex] = newClickedData;
        } else {
          updatedData[currentLayoutKey].push(newClickedData);
        }

        Object.keys(updatedData).forEach((layoutKey) => {
          if (layoutKey === currentLayoutKey) return;

          if (!updatedData[layoutKey]) updatedData[layoutKey] = [];

          const index = updatedData[layoutKey].findIndex(
            (data) => data.parentName === parentName
          );

          if (index !== -1) {
            updatedData[layoutKey][index] = newClickedData;
          } else {
            updatedData[layoutKey].push(newClickedData);
          }
        });

        // hideGrain is derived from clickedData in an effect now — setting Nav's
        // state from inside Home's setClickedData updater ran during Home's
        // render phase. See the comment on that effect.
        return updatedData;
      });

      const newClickedImage = {
        name: assetImageName?.name,
        category: categoryName,
        categoryId: assetImageName?.id,
        color_id: resolvedApiColorId ?? assetImageName?.color_id,
        image: matchedImages,
        parentName,
      };

      setClickedImages((prevImages) =>
        [...prevImages.filter((img) => img.parentName !== parentName || img.category !== categoryName), newClickedImage]
      );

      setSelectedImagesPerCategory((prevState) => {
        const updatedState = { ...prevState };

        if (!updatedState[currentLayoutKey]) updatedState[currentLayoutKey] = {};

        updatedState[currentLayoutKey][parentName] = {
          name: assetImageName?.name,
          category: categoryName,
          categoryId: assetImageName?.id,
          image: matchedImages,
          color_id: resolvedApiColorId ?? assetImageName?.color_id,
        };

        Object.keys(updatedState).forEach((key) => {
          if (key === currentLayoutKey) return;
          if (!updatedState[key]) return;

          if (updatedState[key][parentName]) {
            updatedState[key][parentName] = {
              name: assetImageName?.name,
              category: categoryName,
              categoryId: assetImageName?.id,
              image: matchedImages,
              color_id: resolvedApiColorId ?? assetImageName?.color_id,
            };
          }
        });

        return updatedState;
      });

      setSelectedChildCategory({ assetImageName, name: categoryName });
      setSelectedImage({
        name: assetImageName?.name,
        category: categoryName,
        categoryId: assetImageName?.id,
        color_id: resolvedApiColorId ?? assetImageName?.color_id,
      });

      if (matchedImages.length > 0) {
        onImageClick(matchedImages, parentName, selectedAngle, demo);
      }

      setShowChildCategory(true);
      setPopupData(false);
    }
  };



  const handleGrainImageClick = async (Categories, grainName, grainlabel, grainId, parentName, e) => {

    const cleanedData = Object.fromEntries(
      Object.entries(clickedData).map(([key, items]) => [
        key,
        items.filter(item => item.id !== undefined)
      ])
    );
    setIsLoading(true);
    setShowChildCategory(false);
    setHoveredCategoryId(null);
    const newClickedData = {
      parentName: 'Style & Grain',
      categoryName: 'Slab',
      id: grainId,
      imageName: grainName
    };
    const defaultSettings = JSON.parse(Categories.Layout.default_settings || '[]');

    // ✅ flatMap → Promise.all + map(async) + .flat()
    const initialPaths = (
      await Promise.all(
        (Categories?.GroupAssets || []).map(async (category) => {
          const groupAssets = Array.isArray(category.GroupAssetsColor) ? category.GroupAssetsColor : [];

          let colorMatchedAssets = [];
          if (category.name === "Appliances") {
            colorMatchedAssets = groupAssets.filter(asset =>
              defaultSettings.some(ds =>
                ds.appliances && ds.appliances === asset.name
              )
            );
          } else {
            colorMatchedAssets = groupAssets.filter(asset =>
              defaultSettings.some(ds =>
                ds.colro_id?.toString() === asset.color_id?.toString() &&
                ds.group_id?.split(',').includes(category.id.toString())
              )
            );
          }

          if (colorMatchedAssets.length === 0) return [];

          let matchedAsset = colorMatchedAssets.find(asset => asset.grain === grainName);
          if (!matchedAsset) matchedAsset = colorMatchedAssets[0];

          // ✅ await lagao
          const resolvedApiColorId = await getApiColorId(matchedAsset?.color_id);
          const finalColorId = resolvedApiColorId;

          let imagePath = matchedAsset.grain === "NoGrain"
            ? (matchedAsset.asset_image?.image || matchedAsset.asset_image)
            : matchedAsset.asset_image;

          if (cleanedData && Array.isArray(cleanedData[layoutKey])) {
            const clickedItem = cleanedData[layoutKey].find(item =>
              item.parentName?.trim().toLowerCase() === category.name?.trim().toLowerCase()
            );

            if (clickedItem) {
              const matchedCollection = groupAssets.find(color => {
                const collectionName = color.AssetCollection?.name?.trim().toLowerCase();
                const clickedCategory = clickedItem.categoryName?.trim().toLowerCase();

                return collectionName === clickedCategory ||
                  collectionName + 's' === clickedCategory ||
                  collectionName === clickedCategory + 's';
              });

              let finalMatchedColor = null;
              let assetImage = "";

              if (matchedCollection && clickedItem.imageName) {
                const imageNameLower = clickedItem.imageName.trim().toLowerCase();

                const colorByImageName = groupAssets.find(color => {
                  const colorNameLower = color.name?.trim().toLowerCase();
                  if (colorNameLower !== imageNameLower) return false;
                  if (color.grain !== "NoGrain") {
                    return color.grain === grainName;
                  }
                  return true;
                });

                if (colorByImageName) {
                  finalMatchedColor = colorByImageName;
                } else {
                  finalMatchedColor = matchedCollection;
                }
              }

              if (!matchedCollection && clickedItem && clickedItem.parentName === "Appliances" && clickedItem.imageName) {
                const imageNameLower = clickedItem.imageName.trim().toLowerCase();
                const matchedColor = groupAssets.find(color =>
                  color.name?.trim().toLowerCase() === imageNameLower
                );
                if (matchedColor) {
                  finalMatchedColor = matchedColor;
                  assetImage = matchedColor.asset_image;
                }
              }

              if (!matchedCollection && clickedItem && clickedItem.imageName) {
                const imageNameLower = clickedItem.imageName.trim().toLowerCase();
                const matchedColor = groupAssets.find(color =>
                  color.name?.trim().toLowerCase() === imageNameLower
                );
                if (matchedColor) {
                  finalMatchedColor = matchedColor;
                  assetImage = matchedColor.asset_image;
                }
              }

              if (finalMatchedColor) {
                imagePath = finalMatchedColor.grain === "NoGrain"
                  ? (finalMatchedColor.asset_image?.image || finalMatchedColor.asset_image)
                  : finalMatchedColor.asset_image;
              }
            }
          }

          return [{
            path: imagePath,
            category: category.name
          }];
        })
      )
    ).flat().filter(Boolean); // ✅ flat() + filter(Boolean)

    onImageClick(initialPaths, parentName, selectedAngle, 'grain');

    setSelectedImagesPerStaticCategory(prevState => {
      const updatedState = { ...(prevState || {}) };
      updatedState[layoutKey] = String(grainlabel);
      Object.keys(updatedState).forEach(key => {
        if (key === layoutKey) return;
        updatedState[key] = String(grainlabel);
      });
      return updatedState;
    });

    setSelectedImagesPerCategory(prevState => {
      const updatedState = { ...prevState };
      if (!updatedState[layoutKey]) updatedState[layoutKey] = {};
      updatedState[layoutKey]['Style & Grain'] = {
        name: grainName,
        category: 'Slab',
        categoryId: '',
        image: '',
      };
      Object.keys(updatedState).forEach(key => {
        if (key === layoutKey) return;
        if (!updatedState[key]) return;
        updatedState[key]['Style & Grain'] = {
          name: grainName,
          category: 'Slab',
          categoryId: '',
          image: '',
        };
      });
      return updatedState;
    });

    // Match on newClickedData.parentName ("Style & Grain"), NOT the parentName
    // argument. The grain swatches live in the static popup, whose popupData is
    // { category, type: 'static' } with no parentName — so that argument arrives
    // undefined, findIndex never matched, and every grain click PUSHED another
    // "Style & Grain" entry instead of replacing the existing one. Home then
    // resolves finalArray with .find(), which returns the FIRST match — the stale
    // one — so the price panel kept showing the original grain forever.
    const grainParentName = newClickedData.parentName;

    setClickedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[layoutKey]) updatedData[layoutKey] = [];
      const existingIndex = updatedData[layoutKey].findIndex(
        d => d.parentName === grainParentName
      );
      if (existingIndex !== -1) {
        updatedData[layoutKey][existingIndex] = newClickedData;
      } else {
        updatedData[layoutKey].push(newClickedData);
      }
      Object.keys(updatedData).forEach(key => {
        if (key === layoutKey) return;
        if (!updatedData[key]) updatedData[key] = [];
        const idx = updatedData[key].findIndex(
          d => d.parentName === grainParentName
        );
        if (idx !== -1) {
          updatedData[key][idx] = newClickedData;
        } else {
          updatedData[key].push(newClickedData);
        }
      });
      return updatedData;
    });

    setSelectedGrain(grainName);
    setShowChildCategory(false);
    setShowChildCategory(true);
    setPopupData(false);
  };



  const handleStaticCategoryClick = (categoryId) => {
    setIsPanelOpen(false);
    setEmailOnPrint(null);
    setShowEmailPopup(null);

    setIsCameraDropdownOpen(null)
    setShowLayout(null)
    setSelectedCategoryId(categoryId);
    setShowChildCategory(true);
    setExpandedStaticCategory(expandedStaticCategory === categoryId ? null : categoryId);

    const selectedCategory = staticCategories.find((category) => category.id === categoryId);


    if (selectedCategory) {
      setSelectedMasterCategory({ name: selectedCategory.name });
      setSelectedChildCategory({ name: selectedCategory.ChildCategory[0] });
      setSelectedsubCate('');
    }


    setPopupData({ category: VisualizerCategory, type: 'static' });
  };

  const toggleCameraDropdown = () => {
    setShowEmailPopup(null);
    setIsCameraDropdownOpen(!isCameraDropdownOpen);
    setShowChildCategory(null)
    setShowLayout(null)
    setEmailOnPrint(null)
  };


  const handleToggleEmailPopup = () => {
    setName('')
    setComment('')
    setEmail('')
    setEmailError('')
    setNameError('')
    setShowEmailPopup(!showEmailPopup);
    setEmailOnPrint(false)
    setIsCameraDropdownOpen(null);
    setShowChildCategory(null)
    setShowLayout(null)
  };



  const handlePrintEmailChange = (e) => {
    const updatedEmail = e.target.value;
    setprintemail(updatedEmail);
    // validateEmail(updatedEmail);

  };

  const handleMasterCategoryClick = (masterCategory) => {
    setSelectedsubCate('')
  };

  const handleSubCategoryClick = (subCategory) => {
    setExpandedCategory(selectedExpanded)
    setExpandedagain(true);
  };

  const handleViewClick = async (angleValue) => {
    if (angleValue === selectedView) return;
    setSelectedAngle(angleValue);
    setSelectedView(angleValue)
    await new Promise((resolve) => setTimeout(resolve, 0));
    if (fetchDataRef?.current) await fetchDataRef.current(angleValue);
  };



  let categoryName = '';

  if (selectedImagesPerCategory && selectedMasterCategory && selectedImagesPerCategory[selectedMasterCategory.name]) {
    categoryName = selectedImagesPerCategory[selectedMasterCategory.name]?.category || '';
  }

  // "Cabinets"-type categories must always appear first in the nav, regardless
  // of the order the API returns GroupAssets in (e.g. a layout can list its
  // Cabinets group last). Sort is stable, so relative order within each group
  // (Cabinets vs. everything else) is preserved.
  const sortedGroupAssets = [...(VisualizerCategory.GroupAssets || [])].sort((a, b) => {
    const aIsCabinet = a.category === 'Cabinets' ? 0 : 1;
    const bIsCabinet = b.category === 'Cabinets' ? 0 : 1;
    return aIsCabinet - bIsCabinet;
  });

  const currentLayoutType = React.useMemo(() => {
    if (!layoutKey || !VisualizerCategory.Layouts) return null;
    const matchedLayout = VisualizerCategory.Layouts.find(
      (layout) => layout.key === layoutKey
    );
    return matchedLayout?.type || null;
  }, [layoutKey, VisualizerCategory.Layouts]);

  const currentLayoutTag = React.useMemo(() => {
    if (!layoutKey || !VisualizerCategory.Layouts) return null;
    const matchedLayout = VisualizerCategory.Layouts.find(
      (layout) => layout.key === layoutKey
    );
    return matchedLayout?.tag || null;
  }, [layoutKey, VisualizerCategory.Layouts]);

  const filteredLayouts = React.useMemo(() => {
    if (!VisualizerCategory.Layouts) return [];

    const list = currentLayoutTag
      ? VisualizerCategory.Layouts.filter((layout) => layout.tag === currentLayoutTag)
      : VisualizerCategory.Layouts;

    // Show them in the order set on the admin Layouts screen. Copied before
    // sorting because the no-tag branch hands back VisualizerCategory.Layouts
    // itself, and sorting in place would reorder the shared API data.
    // Layouts without a sort_order sink to the end rather than jumping to front.
    return [...list].sort(
      (a, b) =>
        (typeof a.sort_order === 'number' ? a.sort_order : Number.MAX_SAFE_INTEGER) -
        (typeof b.sort_order === 'number' ? b.sort_order : Number.MAX_SAFE_INTEGER)
    );
  }, [VisualizerCategory.Layouts, currentLayoutTag]);

  return (
    <div id="main-nav" className="absolute top-0 w-full z-50 print:hidden">
      <div className="flex justify-between items-start py-3 shadow-md" style={{ backgroundColor: 'rgba(0, 0, 0, 0.29)' }}>
        {VisualizerCategory.GroupAssets && VisualizerCategory.GroupAssets.length > 0 ? (
          <>
            {/* Left Section */}
            <div className="flex ms-[3.65%] me-[0.4%] items-center max-w-[6.6%] left-section print:hidden">
              <button onClick={handleLayout} className="flex justify-center items-center mx-[0.41rem] " title="Room Layout & Design">
                <img src={Layout} alt="Layout" className="border border-black bg-white xl:w-[2.2rem] xl:h-[1.85rem] layout-img_font px-[2px]" height="1em" width="1em" />
                 

              </button>

              <button onClick={toggleCameraDropdown} className=" relative flex justify-center items-center mx-[0.41rem] " title='Camera Angle'>

                <img src={Camera} alt="Camera Angle" className='border border-black bg-white xl:w-[2.2rem] xl:h-[1.85rem] layout-img_font' />
                {isCameraDropdownOpen && (
                  <div className="absolute bg-slate-50 border border-black shadow-lg rounded-md top-5 xl:top-8 w-[10rem] m-auto z-20">
                    <ul className="divide-y divide-black">
                      {VisualizerCategory.Angles?.angles &&
                        Object.entries(VisualizerCategory.Angles.angles).map(([key, angle]) => {


                          return (
                            <li
                              key={key}
                              className={`flex justify-center items-center py-0.5 xl:py-2 xl:px-4 text-sm cursor-pointer ${selectedView.toString() === key
                                ? 'bg-gray-300 font-semibold rounded-md'
                                : 'hover:bg-gray-200 hover:rounded-md'
                                }`}
                              title={angle.name}
                              onClick={() => handleViewClick(key)}
                            >
                              <p className="xl:text-base text-[0.65rem]">{angle.name}</p>
                            </li>

                          );
                        })}
                    </ul>
                  </div>
                )}



              </button>
            </div>

            {/* Middle Section */}
            <div className="flex  mx-[0.55%] text-center w-[83.5%] middle-section print:hidden">
              {staticCategories.map((category) => (
                <div
                  key={category.id}
                  className="relative border border-black bg-white text-black hover:text-yellow-500 mx-[0.41rem] w-[14%]"
                  title={category.name}
                >
                  <div
                    className={` ${(selectedCategoryId === category.id) && showChildCategory ? 'bg-black text-white' : ''} relative px-[1px] xl:pt-[0.35rem] xl:pb-[0.35rem] md:pb-[0.17rem] md:pt-[0.17rem] font-[540] h-auto focus:outline-none cursor-pointer uppercase text-[0.7rem] text-center`}

                    onClick={() => handleStaticCategoryClick(category.id)}
                  >
                    <span className='xl:text-[0.7rem] text-[0.5rem] font-check'>{category.name}</span>
                    <div
                      className={`${showChildCategory && (selectedCategoryId !== category.id) ? 'absolute bottom-0 left-[10%] right-[10%] h-[1px] bg-black' : ''}`}
                      style={{
                        width: '85%',
                      }}
                    ></div>
                  </div>

                  {/* Static Subcategories */}
                  <>
                    {category.ChildCategory && category.ChildCategory.length > 0 && showChildCategory && (
                      <>
                        <h3 className="text-gray-400 py-0.5 text-[0.5rem] xl:text-[0.72rem] text-center font-[600]">Slab</h3>

                        <p className="text-black testing flex py-0.5 px-[1px] text-[0.47rem] xl:text-[0.72rem] text-center border-gray-300 justify-center items-center font-[600]">
                          <span className=''>
                            {hideGrain ? (
                              "N/A"
                            ) : (
                              (() => {
                                const value = selectedImagesPerStaticCategory &&
                                  typeof selectedImagesPerStaticCategory[layoutKey] !== 'undefined'
                                  ? selectedImagesPerStaticCategory[layoutKey]
                                  : selectedImagesPerStaticCategory;

                                if (value == null) return '';
                                if (typeof value === 'string') return value.trim();
                                if (Array.isArray(value)) {
                                  const first = value.find(v => typeof v === 'string' && v.trim());
                                  return first ? first.trim() : '';
                                }
                                if (typeof value === 'object') {
                                  const labels = Object.values(value)
                                    .map(v => (typeof v === 'string' ? v.trim() : String(v || '').trim()))
                                    .filter(Boolean);
                                  const uniqueLabels = [...new Set(labels)];
                                  return uniqueLabels.length === 1 ? uniqueLabels[0] : uniqueLabels.join(', ');
                                }

                                return String(value);
                              })()
                            )}
                          </span>
                        </p>
                      </>
                    )}






                  </>

                </div>
              ))
              }

              {VisualizerCategory.GroupAssets &&
                Array.isArray(VisualizerCategory.GroupAssets) &&
                VisualizerCategory.GroupAssets.length > 0 ? (

                sortedGroupAssets.map((cat, index) => {

                  const masterCategory = cat;
                  const defaultSettings = JSON.parse(VisualizerCategory.Layout.default_settings || "[]");

                  const matchedDefault = defaultSettings.find(setting => {
                    const groupIds = setting.group_id?.split(",") || [];
                    return groupIds.includes(String(masterCategory.id));
                  });

                  let defaultColorName = "";
                  let defaultCollectionName = "";

                  if (matchedDefault && masterCategory.GroupAssetsColor?.length > 0) {
                    const matchedColor = masterCategory.GroupAssetsColor.find(
                      (colorObj) => String(colorObj.AssetColor?.id) === String(matchedDefault.colro_id)
                    );

                    if (matchedColor) {
                      defaultColorName = matchedColor.AssetColor?.name || "";
                      if (matchedColor.AssetCollection) {
                        defaultCollectionName = matchedColor.AssetCollection?.name || "";
                      } else {
                        defaultCollectionName = matchedColor?.type || "";
                      }
                    }
                  }

                  // The lookup above reads GroupAssetsColor, which is per-ANGLE:
                  // Tall Cabinets has 722 colours on V1/V2 but 0 on V3, so on V3
                  // it found nothing and the tile fell through to "N/A" even though
                  // the layout does define a default for it. That is why the value
                  // only appeared once the user changed something (which writes a
                  // selection) and not on a plain load. Collections is layout-level
                  // rather than per-angle, so resolve the default colour there.
                  // Gated on belongsToLayout so a category absent from the WHOLE
                  // layout (bathroom Base/Wall/Island) still shows N/A.
                  if (
                    !defaultColorName &&
                    matchedDefault &&
                    belongsToLayout(masterCategory)
                  ) {
                    for (const collection of sortedCollection) {
                      const found = collection.CollectionColor?.find(
                        (cc) => String(cc.id) === String(matchedDefault.colro_id)
                      );
                      if (found) {
                        defaultColorName = found.name || "";
                        defaultCollectionName = collection.name || "";
                        break;
                      }
                    }
                  }


                  // A category the layout has no assets for in any angle shows no
                  // selection at all, so the block below falls through to the
                  // default branch and renders "N/A" — it must never display, or
                  // inherit, a colour. Seeding this layout from an already
                  // configured one now happens in an effect above, not here:
                  // calling setState during render was what triggered React's
                  // "Cannot update a component while rendering" warning.
                  const selectedCategoryData = belongsToLayout(masterCategory)
                    ? selectedImagesPerCategory?.[layoutKey]?.[masterCategory.name]
                    : null;

                  let matchedAppliance = null;
                  let assetArray = [];

                  if (masterCategory.name?.trim().toLowerCase() === "appliances") {
                    const defaultApplianceSetting = defaultSettings.find(ds => ds.appliances);

                    matchedAppliance = masterCategory.GroupAssetsColor?.find(
                      (color) => color.name === defaultApplianceSetting?.appliances
                    );
                  }


                 const hasNoColors = !masterCategory.GroupAssetsColor || masterCategory.GroupAssetsColor.length === 0;
const isCategoryHidden = hasNoColors && masterCategory.default_display_menu === 0;
const isCategoryDisabled = hasNoColors && masterCategory.default_display_menu === 1;

return masterCategory && masterCategory.name && !isCategoryHidden ? (
                    <div
                      key={masterCategory.id}
                      className={`relative border border-black bg-white text-black mx-[0.41rem] w-[14%] ${isCategoryDisabled ? 'opacity-40 cursor-not-allowed' : 'hover:text-yellow-500'
                        }`}
                      title={masterCategory.name}
                    >
                      <div
                        className={`${(selectedCategoryId === masterCategory.id) && showChildCategory
                          ? 'bg-black text-white'
                          : ''
                          } px-[1px] md:pb-[0.17rem] md:pt-[0.17rem] xl:pt-[0.35rem] xl:pb-[0.35rem] font-[540] h-auto focus:outline-none uppercase text-[0.7rem] text-center relative ${isCategoryDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
                          }`}
                        onClick={() => !isCategoryDisabled && handleCategoryClick(cat)}
                      >
                        <span className='xl:text-[0.7rem] text-[0.52rem] font-check'>{masterCategory.name}</span>
                        <div
                          className={`${showChildCategory && (selectedCategoryId !== masterCategory.id)
                            ? 'absolute bottom-0 left-[10%] right-[10%] h-[1px] bg-black'
                            : ''
                            }`}
                          style={{ width: '80%' }}
                        ></div>
                      </div>

                      {/* Show default color when nothing selected */}

                      {!selectedCategoryData && showChildCategory && (
                        <>
                          <div className="flex items-center justify-center gap-1 px-[1px] py-[1px]">
                            <h3 className="text-gray-400 py-0.5 text-[0.5rem] xl:text-[0.72rem] text-center font-[600] m-0">
                              {masterCategory.name?.trim().toLowerCase() === "appliances"
                                ? "Standard"
                                : defaultCollectionName}
                            </h3>

                           {masterCategory?.category === "Cabinets" && !isCategoryDisabled && !isAppliances(masterCategory.name) && (
                              <img
                                src={ApplyAll}
                                alt="icon"
                                className={`w-5 h-5 flex-shrink-0 ml-1 p-[1px] ${isApplyAllInProgress ? 'cursor-not-allowed opacity-50 ' : 'cursor-pointer'}`}
                                title="Apply to All Cabinets"
                                onClick={(e) => {
                                  if (isApplyAllInProgress) return;
                                  e.stopPropagation();
                                  handleDefaultClick(
                                    matchedAppliance?.name || defaultColorName,
                                    assetArray,
                                    VisualizerCategory.GroupAssets.filter(g => g.category === "Cabinets" && g.GroupAssetsColor?.length > 0),
                                    defaultCollectionName
                                  );
                                }}
                              />
                            )}
                          </div>
                          <p className="text-black flex items-center justify-center gap-1 text-[0.5rem] xl:text-[0.7rem] py-0.5 px-[1px] font-[600] border-gray-300 text-center">
                            <span className=''>{(() => {
                              let finalName = "";

                              if (
                                masterCategory.name?.trim().toLowerCase() === "appliances"
                              ) {
                                const defaultApplianceSetting = defaultSettings.find(
                                  (ds) => ds.appliances
                                );

                                matchedAppliance = masterCategory.GroupAssetsColor?.find(
                                  (color) =>
                                    color.name === defaultApplianceSetting?.appliances
                                );

                                finalName = matchedAppliance?.name || "Standard";
                              } else {
                                finalName = defaultColorName || "N/A";
                              }
                              assetArray.push({
                                path: finalName,
                                category: masterCategory.name,
                              });

                              return finalName;
                            })()}</span>

                          </p>
                        </>
                      )}


                      {/* Show selected category */}
                      {showChildCategory && selectedCategoryData && (
                        <>
                          {(() => {

                            assetArray.push({
                              path: selectedCategoryData.name,
                              category: selectedCategoryData.category,
                            });
                            return null;
                          })()}
                          <div className="flex items-center justify-center gap-1 px-[1px] py-[1px]">
                            <h3 className="text-gray-400 py-0.5 text-[0.5rem] xl:text-[0.72rem] text-center font-[600] m-0">
                              {selectedCategoryData.category}
                            </h3>
                            {/* No wrapper around the image below. It used to sit in a
                                span with pr-1, and that span was the flex item, not
                                the image — so the image's own flex-shrink-0 protected
                                nothing and a long collection name squeezed the span,
                                halving the icon to ~10px. The default-colour row above
                                never had the wrapper, which is why only the selected
                                state shrank. */}
                            {masterCategory.category === "Cabinets" && !isCategoryDisabled && !isAppliances(masterCategory.name) && (
                              <img
                                src={ApplyAll}
                                alt="icon"
                                className={`w-5 h-5 flex-shrink-0 ml-1 p-[1px] ${isApplyAllInProgress ? 'cursor-not-allowed opacity-50 ' : 'cursor-pointer'}`}
                                title="Apply to All Cabinets"
                                onClick={(e) => {
                                  if (isApplyAllInProgress) return;
                                  e.stopPropagation();
                                  handleDefaultClick(
                                     selectedCategoryData.name,
                                    assetArray,
                                    VisualizerCategory.GroupAssets.filter(g => g.category === "Cabinets" && g.GroupAssetsColor?.length > 0),
                                    selectedCategoryData.category
                                  );
                                }}
                              />
                            )}
                          </div>
                          <p className="text-black flex items-center justify-center gap-1 text-[0.5rem] xl:text-[0.7rem] py-0.5 px-[1px] font-[600] border-gray-300 text-center">
                            <span className='ccc'>{selectedCategoryData.name}</span>

                          </p>
                        </>
                      )}

                    </div>
                  ) : (
                    <li key={cat.id} className="list-none"></li>
                  );
                })
              ) : (
                <div></div>
              )}


            </div>


            {/* RIGHT SECTION */}
            <div className="flex items-center ms-[0.4%] me-[3.65%]  max-w-[9.9%] right-section print:hidden">
              <button
                className="flex justify-center items-center mx-[0.41rem] "
                onClick={handleToggleChildCategory}
                title={showChildCategory ? "Hide Options" : "Show Options"}
              >

                {showChildCategory ? <img src={FaEysSlash} className='bg-white border border-black bot xl:w-[2.2rem] xl:h-[1.85rem] px-[1px] layout-img_font' /> : <img src={FaEys} className='bg-white border border-black  xl:w-[2.2rem] xl:h-[1.85rem] px-[1px] layout-img_font' />}
              </button>
              <button className="flex justify-center items-center mx-[0.41rem] " title="Print">

                <img src={Print} onClick={printLayout} className='bg-white border border-black xl:w-[2.2rem] xl:h-[1.85rem] px-[1px] layout-img_font' />

              </button>
              <button className="flex  justify-center items-center mx-[0.41rem] " title="Mail" onClick={handleToggleEmailPopup}>
                <img src={Email} alt="Email" className='border border-black bg-white xl:w-[2.2rem] xl:h-[1.85rem] layout-img_font' />
              </button>
            </div>

            {showEmailPopup && (
              <div className="absolute top-36 xl:top-48 left-1/2 transform -translate-x-1/2 bg-white p-4 shadow-lg rounded-md w-[22rem] xl:w-auto">
                <h3 className="text-sm xl:text-lg font-semibold mb-2">Send Email</h3>
                <div className="flex">
                  <div className='me-2'>
                    <label htmlFor="" className='text-[0.6rem] xl:text-sm text-gray-500 ms-1 font-semibold'>Name: <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      value={name}
                      onChange={handleNameChange}
                      placeholder="Enter recipient name"
                      className="w-full p-0.5 xl:p-2 border border-gray-300 xl:text-base  md:text-[.75rem] rounded-md placeholder:text-[0.63rem] xl:placeholder:text-sm"
                    />
                    {nameError && <p className="text-red-400 md:text-[0.6rem] xl:text-xs mt-1">{nameError}</p>}
                  </div>
                  <div className=''>
                    <label htmlFor="" className='text-[0.6rem] xl:text-sm text-gray-500 ms-1 font-semibold'>Email: <span className="text-red-500">*</span></label>
                    <input
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Enter recipient email"
                      className="w-full p-0.5 xl:p-2 border border-gray-300  xl:text-base  md:text-[.75rem] rounded-md placeholder:text-[0.63rem] xl:placeholder:text-sm"
                    />
                    {emailError && <p className="text-red-400 md:text-[0.6rem] xl:text-xs mt-1">{emailError}</p>}
                  </div>
                </div>
                <label htmlFor="" className='text-[0.6rem] xl:text-sm text-gray-500 ms-1 font-semibold'>Comment</label>
                <textarea
                  type="text"
                  value={comment}
                  onChange={handleCommentChange}
                  placeholder="Commment"
                  className="w-full p-0.5 xl:p-2 mb-4 border border-gray-300 xl:text-base  md:text-[.75rem] rounded-md placeholder:text-[0.65rem] xl:placeholder:text-sm"
                />
                <div className="flex justify-between items-center">
                  <button
                    onClick={() => handleSendEmailForPrint('Email')}
                    className="bg-blue-500 text-white xl:text-base text-[0.7rem] py-1 px-1.5 xl:py-2 xl:px-4 rounded-md"
                  >
                    Send
                  </button>
                  <button
                    onClick={() => setShowEmailPopup(false)}
                    className="bg-gray-500 text-white xl:text-base text-[0.7rem] py-1 px-1.5 xl:py-2 xl:px-4 rounded-md"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            {emailOnPrint && (
              <div className="absolute top-36 xl:top-48 left-1/2 transform -translate-x-1/2 bg-white p-4 shadow-lg rounded-md w-[22rem] xl:w-auto">
                <h3 className=" text-sm xl:text-lg font-semibold mb-2">Print</h3>
                <div className="flex">
                  <div className='me-2'>
                    <label htmlFor="" className='text-[0.6rem] xl:text-sm text-gray-500 ms-1 font-semibold'>Name: <span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      value={name}
                      onChange={handleNameChange}
                      placeholder="Enter recipient name"
                      className="w-full p-0.5 xl:p-2 border border-gray-300 xl:text-base  md:text-[.75rem] rounded-md placeholder:text-[0.65rem] xl:placeholder:text-sm"
                    />
                    {nameError && <p className="text-red-400 md:text-[0.6rem] xl:text-xs mt-1">{nameError}</p>}
                  </div>
                  <div className=''>
                    <label htmlFor="" className='text-[0.6rem] xl:text-sm text-gray-500 ms-1 font-semibold'>Email: <span className="text-red-500">*</span></label>
                    <input
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Enter recipient email"
                      className="w-full p-0.5 xl:p-2 border border-gray-300 xl:text-base  md:text-[.75rem] rounded-md placeholder:text-[0.65rem] xl:placeholder:text-sm"
                    />
                    {emailError && <p className="text-red-400 md:text-[0.6rem] xl:text-xs mt-1">{emailError}</p>}
                  </div>
                </div>
                <label htmlFor="" className='text-[0.6rem] xl:text-sm text-gray-500 ms-1 font-semibold'>Comment</label>
                <textarea
                  type="text"
                  value={comment}
                  onChange={handleCommentChange}
                  placeholder="Commment"
                  className="w-full p-0.5 xl:p-2 mb-4 border border-gray-300 xl:text-base  md:text-[.75rem] rounded-md placeholder:text-[0.65rem] xl:placeholder:text-sm"
                />
                <div className="flex justify-between items-center">
                  <button
                    onClick={() => handleSendEmailForPrint('Print')}
                    className="bg-blue-500 text-white xl:text-base text-[0.7rem] py-1 px-1.5 xl:py-2 xl:px-4 rounded-md"
                  >
                    Print
                  </button>
                  <button
                    onClick={() => setEmailOnPrint(false)}
                    className="bg-gray-500 text-white xl:text-base text-[0.7rem] py-1 px-1.5 xl:py-2 xl:px-4 rounded-md"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </>
        ) : null}
      </div>

      {showChildCategory && popupData && (

        <div className="bg-black px-4 py-[0.2rem] text-white uppercase right-section print:hidden">
          <div className="bg-opacity-75 text-white uppercase mx-[2.8%] text-[0.7rem] xl:text-base">


            {
              selectedMasterCategory ? (
                <a href="#" onClick={() => handleMasterCategoryClick(selectedMasterCategory)}>
                  {selectedMasterCategory.name}
                </a>
              ) : ''
            }

            {
              selectedsubCate ? (
                <span onClick={(e) => e.stopPropagation()}>
                  {' > '}
                  {/* The breadcrumb bar uppercases everything in it, which is
                      right for the category name beside it but would undo the
                      label's own casing — so a label opts out, while a
                      collection falling back to its name stays uppercase. */}
                  <a
                    href="#"
                    className={collectionLabelHtml(selectedsubCate).styled ? "normal-case" : ""}
                    dangerouslySetInnerHTML={{
                      __html: collectionLabelHtml(selectedsubCate).html,
                    }}
                  />
                </span>
              ) : ''
            }


            {/*{selectedImagesPerCategory && selectedMasterCategory && selectedImagesPerCategory[layoutKey] &&
        selectedImagesPerCategory[layoutKey][selectedMasterCategory.name] 
        ? selectedImagesPerCategory[layoutKey][selectedMasterCategory.name]?.category
        : Defaultname}*/}
          </div>
        </div>
      )}
      {popupData && showChildCategory && (
        (() => {
          const { defaultGrain, category, type, parentName } = popupData;

          if (type === "dynamic") {
            const childCategories = category ? category.GroupAssetsColor || [] : [];

            // Indexed by category id (not array position) so it stays correct
            // regardless of where "Cabinets"-type categories fall in the API order.
            const demo = [];
            VisualizerCategory.GroupAssets.forEach((item) => {
              // Appliances is filed under category "Cabinets" by the API, which
              // put it on the compact 3-column cabinet grid (small thumbnails,
              // capped at 9 with a "+more"). It only ever has two options, so it
              // belongs with Backsplash/Countertop/Flooring — full-size
              // thumbnails, all shown.
              demo[item.id - 1] =
                item.category === "Cabinets" && !isAppliances(item.name);
            });

            const groupAssets = Array.isArray(category.GroupAssetsColor)
              ? category.GroupAssetsColor
              : [];

            const hasCollections = childCategories.some(
              (item) => item.AssetCollection && item.AssetCollection.id
            );

            let groupedChildCategories = [];

            if (hasCollections) {
              const collectionsMap = new Map();

              childCategories.forEach((item) => {
                const collection = item.AssetCollection;
                if (!collection) return;

                const name = collection.name;

                if (!collectionsMap.has(name)) {
                  collectionsMap.set(name, {
                    id: collection.id,
                    name,
                    VisualizerAssetsColors: new Map(),
                  });
                }

                collectionsMap.get(name).VisualizerAssetsColors.set(item.id, item);
              });

              groupedChildCategories = Array.from(collectionsMap.values()).map((col) => ({
                id: col.id,
                name: col.name,
                VisualizerAssetsColors: Array.from(col.VisualizerAssetsColors.values()),
              }));
            } else {
              const uniqueAssets = [
                ...new Map(groupAssets.map((item) => [item.id, item])).values(),
              ];

              const typeGroups = uniqueAssets.reduce((acc, item) => {
                const typeName = item.type || "Standard";
                if (!acc[typeName]) acc[typeName] = [];
                acc[typeName].push(item);
                return acc;
              }, {});

              groupedChildCategories = Object.entries(typeGroups).map(
                ([typeName, items]) => ({
                  id: items[0]?.id,
                  name: typeName,
                  VisualizerAssetsColors: items,
                })
              );
            }

            const collectionOrderMap = new Map(
              sortedCollection.map((col, index) => [col.id, index])
            );

            // Groups without a collection (Backsplash/Countertop/Flooring are
            // grouped by `type` instead) find nothing in collectionOrderMap, so
            // they all scored MAX_SAFE_INTEGER and fell back to API order. That
            // put Flooring's "Tile" group ahead of "Wood" even though Wood holds
            // sort_order 1 and 2. Rank those groups by the lowest sort_order they
            // contain, so the groups themselves follow the order set in admin.
            // Collection-backed groups (cabinets) keep using the map untouched.
            const groupMinSortOrder = (group) => {
              const orders = (group.VisualizerAssetsColors || [])
                .map((i) => i.AssetColor?.sort_order)
                .filter((v) => typeof v === 'number');
              return orders.length ? Math.min(...orders) : Number.MAX_SAFE_INTEGER;
            };

            groupedChildCategories.sort((a, b) => {
              const orderA = collectionOrderMap.get(a.id) ?? groupMinSortOrder(a);
              const orderB = collectionOrderMap.get(b.id) ?? groupMinSortOrder(b);
              return orderA - orderB;
            });

            // What is currently selected for the tile this popup belongs to, so
            // the matching collection and swatch can be marked. Matched on NAME,
            // not asset id: changing the grain swaps in a different asset row for
            // the same colour, and an id match would lose the highlight.
            const selectedForParent =
              selectedImagesPerCategory?.[layoutKey]?.[parentName];

            // Nothing clicked yet on a first open, but the tile is already showing
            // the layout default — so resolve that default and mark it, otherwise
            // the popup reads as "nothing selected" while the tile says otherwise.
            // popupData.defaultColor cannot be used: handleCategoryClick builds it
            // from category.Layout, and a GroupAssets item has no Layout property,
            // so it always comes back empty. Read default_settings from
            // VisualizerCategory.Layout instead — the same source the tile uses.
            const popupDefaults = (() => {
              const group = popupData?.category;
              const ds = JSON.parse(
                VisualizerCategory?.Layout?.default_settings || "[]"
              );

              // Appliances stores its default differently from every other
              // category: its group id is in no group_id list, and the default
              // lives under its own `appliances` key rather than a colro_id. Its
              // assets also carry no AssetColor/AssetCollection and an empty
              // type, so they group under "Standard" — which is what the tile
              // shows as their collection line.
              if (isAppliances(group?.name)) {
                return {
                  colour: ds.find((s) => s.appliances)?.appliances || "",
                  collection: "Standard",
                };
              }

              const matched = ds.find((s) =>
                (s.group_id?.split(",") || []).includes(String(group?.id))
              );
              if (!matched) return {};

              const colorObj = (group?.GroupAssetsColor || []).find(
                (c) => String(c.AssetColor?.id) === String(matched.colro_id)
              );
              if (!colorObj) return {};

              return {
                colour: colorObj.AssetColor?.name || "",
                collection: colorObj.AssetCollection?.name || colorObj?.type || "",
              };
            })();

            const selectedCollectionName =
              selectedForParent?.category || popupDefaults.collection;
            const selectedColourName =
              selectedForParent?.name || popupDefaults.colour;

            // Drawn INSIDE the tile. The expanded grid scrolls inside
            // `overflow-auto overflow-x-hidden`, which clips anything sticking
            // out — a badge on negative offsets was getting sliced at the edge.
            const tickBadge = (size) => (
              <span
                className="absolute top-1 right-1 z-10 rounded-full bg-green-500 text-white flex items-center justify-center font-bold leading-none"
                style={{ width: size, height: size, fontSize: size * 0.62 }}
              >
                ✓
              </span>
            );




            return (
              <div className="relative right-section print:hidden">
                <div className="absolute top-0 left-0 right-0 w-full pt-2 pr-4 pb-8 pl-4 bg-black bg-opacity-50 shadow-lg z-50">
                  {/* flex-wrap so the collection groups drop to the next row
                      instead of running off the right edge — six of them are
                      ~260px wider than the popup at 1400px. gap-[20px] already
                      spaces both axes, so wrapped rows get the same gutter. */}
                  <div
                    className={`${demo[popupData.category.id - 1] ? "flex flex-wrap gap-[20px]" : "flex flex-wrap gap-y-4"
                      } relative ms-[2.8%]`}
                  >
                    {[...groupedChildCategories].map((childCategory) => {
                      const isExpanded = expandedCategory === childCategory.id;

                      if (expandedagain && !isExpanded) return null;

                      /* -------- UNIQUE ASSETS -------- */
                      // The API can return two rows with the SAME name where only
                      // one is complete — Backsplash "Mosaic Tile" exists as id
                      // 60121 (AssetColor: null) and id 60155 (AssetColor set) —
                      // and it returns them in a non-deterministic order (no ORDER
                      // BY). A plain Map keeps whichever arrived LAST, so roughly
                      // half of all loads kept the broken row and rendered
                      // ".../undefined"; a refresh reshuffled the order and it
                      // "fixed itself". Pick the most complete row per name instead
                      // of the last one, so the choice no longer depends on order.
                      const thumbScore = (a) =>
                        a?.AssetColor?.thumbnail_image ? 2 : a?.asset_thumbnail ? 1 : 0;

                      const uniqueAssets = [
                        ...childCategory.VisualizerAssetsColors.reduce((map, item) => {
                          const existing = map.get(item.name);
                          if (!existing || thumbScore(item) > thumbScore(existing)) {
                            map.set(item.name, item);
                          }
                          return map;
                        }, new Map()).values(),
                      ];

                      const assetsToShow =
                        demo[popupData.category.id - 1] && !isExpanded
                          ? 9
                          : uniqueAssets.length;

                      return (
                        <div
                          key={childCategory.id}
                          className={`${isExpanded ? "w-full" : ""} mx- mt-5`}
                          onClick={(e) => {
                            setExpandedCategory(
                              expandedCategory === childCategory.id
                                ? null
                                : childCategory.id
                            );
                            e.stopPropagation();
                            setExpandedagain(true);
                          }}
                        >
                          {/* Labels ("SHINNOKI by DECOSPAN") run 12-20 chars against a
                              150/210px heading box, so some wrap to two lines. The
                              min-height with centred content keeps every heading the
                              same height — otherwise the swatch grids underneath would
                              start at different y positions. */}
                          <h2
                            style={{
                              background:
                                "linear-gradient(to right, #FFFECB, #FEFED9, #FEFEF6)",
                              // A styled label carries its own casing, so forcing
                              // uppercase would flatten the small "by MAKER" into
                              // "BY MAKER". Unstyled ones keep the blanket uppercase.
                              textTransform: collectionLabelHtml(childCategory.name).styled
                                ? "none"
                                : "uppercase",
                            }}
                            className={`${isExpanded || !demo[popupData.category.id - 1]
                              ? "hidden"
                              : "flex items-center justify-center"
                              } relative text-center min-h-[2.4em] leading-tight break-words px-5 text-[0.8rem] mb-4`}
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html: collectionLabelHtml(childCategory.name).html,
                              }}
                            />
                            {childCategory.name === selectedCollectionName && tickBadge(16)}
                          </h2>

                          <div
                            className={`relative
                  ${!isExpanded && demo[popupData.category.id - 1]
                                ? "grid grid-cols-3 gap-0 w-[150px] xl:w-[210px]"
                                : "flex"
                              }
                  ${isExpanded && demo[popupData.category.id - 1]
                                ? "flex flex-wrap h-[16rem] xl:h-96 overflow-auto overflow-x-hidden"
                                : ""
                              }`}
                          >
                            {uniqueAssets
                              .sort((a, b) => {
                                const collectionA = sortedCollection.find(
                                  (c) => c.id === a.collection_id
                                );
                                const collectionB = sortedCollection.find(
                                  (c) => c.id === b.collection_id
                                );

                                const aColor = collectionA?.CollectionColor.find(
                                  (c) => c.id == a.color_id
                                );
                                const bColor = collectionB?.CollectionColor.find(
                                  (c) => c.id == b.color_id
                                );

                                // Backsplash, Countertop and Flooring carry
                                // collection_id 0 with no AssetCollection, so the
                                // collection lookup above finds nothing for them and
                                // they were falling straight through to created_at —
                                // ignoring the order set in admin. Their sort_order
                                // lives on AssetColor, so read it there before giving
                                // up. Cabinets still resolve through the collection
                                // exactly as before; this only adds a step where that
                                // returned nothing.
                                const aOrder =
                                  aColor?.sort_order ??
                                  a.AssetColor?.sort_order ??
                                  new Date(a.created_at).getTime();
                                const bOrder =
                                  bColor?.sort_order ??
                                  b.AssetColor?.sort_order ??
                                  new Date(b.created_at).getTime();

                                return aOrder - bOrder;
                              })
                              .slice(0, assetsToShow)
                              .map((asset, index) => {

                                const assetArray = [
                                  {
                                    path: asset.name,
                                    category: parentName,
                                  },
                                ];

                                // Chain instead of an Appliances-only ternary.
                                // Appliances rows have no AssetColor, so they still
                                // land on asset_thumbnail exactly as before — but so
                                // does any other row missing AssetColor (kitchen
                                // "Havanna Grey", where every duplicate row is
                                // incomplete, so the dedupe above cannot help).
                                // Without this the URL ended in "undefined".
                                const resolvedThumb =
                                  asset?.AssetColor?.thumbnail_image ||
                                  asset?.asset_thumbnail ||
                                  "";

                                // Collection has to match too — the same colour
                                // name can exist in more than one collection.
                                const isSelectedAsset =
                                  childCategory.name === selectedCollectionName &&
                                  asset?.name === selectedColourName;

                                return (
                                  <div
                                    key={asset.id}
                                    className={`${!isExpanded && demo[popupData.category.id - 1]
                                      ? "xl:w-[70px]"
                                      : "xl:w-[10rem] w-[6.5rem]"
                                      } relative`}
                                  >
                                    {/* w-fit shrinks this wrapper to the thumbnail's
                                        own width. Without it the wrapper stretched to
                                        the wider outer cell, so the tick — anchored to
                                        this element — sat off the image's right edge
                                        instead of in its corner. */}
                                    <div
                                      onClick={(e) => e.stopPropagation()}
                                      className={`${isExpanded ? "mb-4" : ""} relative w-fit`}
                                    >
                                      {isSelectedAsset && tickBadge(16)}
                                      <img
                                        src={`${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL}${resolvedThumb}`}
                                        alt={asset.name}
                                        className="w-[6rem] xl:w-[9.4rem] cursor-pointer"
                                        onClick={(e) => {
                                          handleImageClick(
                                            asset,
                                            category,
                                            childCategory.name,
                                            assetArray,
                                            parentName,
                                            e,
                                            demo
                                          );
                                          e.stopPropagation();
                                          setExpandedCategory(childCategory.id);
                                          setSelectedExpanded(childCategory.id);
                                          setExpandedagain(true);
                                        }}
                                      />

                                      {(isExpanded ||
                                        !demo[popupData.category.id - 1]) && (
                                          <p className="absolute bottom-0 w-[6rem] xl:w-[9.4rem] h-[2.8rem] text-white text-center text-[0.5rem] xl:text-sm bg-black bg-opacity-50 flex items-center justify-center px-1 leading-tight line-clamp-2">
                                            {asset.name}
                                          </p>
                                        )}
                                    </div>

                                    {/* + MORE BUTTON */}
                                    {index === 8 &&
                                      uniqueAssets.length > 8 &&
                                      !isExpanded &&
                                      demo[popupData.category.id - 1] && (
                                        <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 shadow-lg z-50 flex justify-center items-center">
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setExpandedCategory(childCategory.id);
                                              setSelectedsubCate(childCategory.name);
                                              setExpandedagain(true);
                                            }}
                                            className="bg-black bg-opacity-50 text-white p-[10px]"
                                          >
                                            <p className="text-xs xl:text-base">
                                              {/* 9 tiles render, but this button's
                                                  overlay covers the 9th — so 8 swatches
                                                  are actually visible and the remainder
                                                  is length - 8. The old -4 over-counted
                                                  by 4 (Shinnoki's 18 read "+14 more"
                                                  when only 10 were left). */}
                                              +{uniqueAssets.length - 8} more
                                            </p>
                                          </button>
                                        </div>
                                      )}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="absolute -top-[1rem] right-0 p-4">
                    <button
                      className="bg-black text-white px-[0.38rem] py-[0.05rem] rounded-full"
                      onClick={closePopup}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                </div>
              </div>
            );
          } else if (type === 'static') {
            const Categories = category ? category || [] : [];

            // The Style & Grain tile shows "Slab" as its collection line, which
            // comes from default_settings.Style (1 = Slab). There is no user
            // selection to read here — handleGrainStyleChange is still a no-op —
            // so the layout default IS the current style.
            const selectedStyleId = JSON.parse(
              VisualizerCategory?.Layout?.default_settings || "[]"
            ).find((d) => d.Style)?.Style;




            return (
              <div className='relative right-section print:hidden'>
                <div className="absolute top-[0rem] left-0 right-0 w-full  pt-2 pr-4 pb-7 pl-4 bg-black bg-opacity-50 shadow-lg z-50">
                  <div className="flex justify-center items-center space-x-2 relative">
                    <div className="flex flex-wrap w-full">
                      <div className="grid grid-cols-[40%,53%] gap-2 mt-5 ms-[2.6%]">

                        {/* Style Section */}
                        <div>
                          <h3 className="text-md font-medium mb-1 bg-gray-300 p-0.5 text-center text-gray-800 uppercase mx-1 text-[0.5rem] xl:text-base">
                            Style
                          </h3>
                          <div className="flex flex-wrap justify-between text-sm">
                            {VisualizerCategory.Styles.map((style) => (
                              <div
                                key={style.id}
                                className="p-1 text-center w-1/3 group cursor-pointer"
                                onClick={() => handleGrainStyleChange({ name: style.name, id: style.id })}
                              >
                                <div className="relative">
                                  {style.id === selectedStyleId && (
                                    <span className="absolute top-2 right-2 z-10 w-[16px] h-[16px] rounded-full bg-green-500 text-white flex items-center justify-center text-[10px] font-bold leading-none">
                                      ✓
                                    </span>
                                  )}
                                  <img
                                    src={`${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL || ""}${style.image}`}
                                    alt={style.name}
                                    className="w-full p-2 xl:p-4 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300"
                                  />
                                  {style.status !== "Active" && (
                                    <div className="absolute top-0 left-0 bg-gray-600 w-full h-full opacity-50"></div>
                                  )}
                                </div>
                                <p className="text-gray-800 bg-gray-300 xl:p-1 text-[0.5rem] xl:text-[0.9rem]">
                                  {style.name.toUpperCase()}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Grain Section */}

                        <div
                          className={`${hideGrain ? "pointer-events-none opacity-50" : ""}`}
                        >
                          <h3 className="text-md font-medium mb-1 bg-gray-300 p-0.5 text-center text-gray-800 uppercase mx-1 text-[0.5rem] xl:text-base">
                            Grain
                          </h3>
                          <div className="flex flex-wrap justify-between text-sm">
                            {VisualizerCategory.Grains.map((grain) => {
                              // hideGrain means no grain direction applies, so
                              // nothing should read as selected in that state.
                              const isSelectedGrain =
                                !hideGrain &&
                                (selectedGrain === grain.name ||
                                  selectedGrain === grain.label);

                              return (
                              <div
                                key={grain.id}
                                className="p-1 text-center w-1/4 group cursor-pointer"
                                onClick={(e) => handleGrainImageClick(Categories, grain.label, grain.name, grain.id, parentName, e)}
                              >
                                {/* Same wrapper + tick offsets as the Style tiles
                                    above, so both read identically. */}
                                <div className="relative">
                                  {isSelectedGrain && (
                                    <span className="absolute top-2 right-2 z-10 w-[16px] h-[16px] rounded-full bg-green-500 text-white flex items-center justify-center text-[10px] font-bold leading-none">
                                      ✓
                                    </span>
                                  )}
                                  <img
                                    src={`${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL || ""}${grain.image}`}
                                    alt={grain.name}
                                    className="w-full p-2 xl:p-4 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300"
                                  />
                                </div>
                                <p className="text-gray-800 bg-gray-300 uppercase px-0 xl:p-1 text-[0.5rem] xl:text-[0.9rem]">
                                  {grain.name.toUpperCase()}
                                </p>
                              </div>
                              );
                            })}
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>

                  <div className="absolute -top-[1rem] right-0 xl:-right- p-4">
                    <button className="bg-black text-white px-[0.38rem] py-[0.05rem] w- rounded-full" onClick={closePopup}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>

                </div>
              </div>
            );
          }



          return null;
        })()
      )}

      {/* LAYOUT */}
      {/* Was py-[0.2rem] around a 1.5 line box, which made a 30px band for a
          12px line of caps. Tighter padding and a line box that hugs the text
          bring it to ~24px without moving the text off centre. */}
      {showLayout && (
        <div className="bg-black px-4 py-[4px] text-white uppercase ">
          {/* The bar's padding is symmetric, but this line is all caps and so
              paints nothing below the baseline, while the line box still reserves
              the descender space. At the xl size that left 5.5px of black above
              the letters and 6.5px below, so half a pixel down centres them.
              Only at xl: measured at the smaller size the two already come out
              even (hinting does not scale the metrics linearly), and applying the
              same nudge there tipped it the other way. Relative, so the bar keeps
              its height. */}
          <div className="relative top-0 xl:top-[0.5px] leading-none xl:leading-none bg-opacity-75 text-white uppercase mx-[2.8%] text-[0.7rem] xl:text-base">
            {currentLayoutType || 'ROOM'} LAYOUT & DESIGN
          </div>
        </div>
      )}
      {showLayout && (
        <div className='relative'>
          {/* p-4, not pt-2/pb-6: the panel had 8px above the layout cards and
              24px below their labels, so the band read lopsided. 16px all round
              evens it up and, because 8+24 and 16+16 come to the same 32, the
              panel keeps the exact height it had — nothing below it moves. */}
          <div className="absolute top-[0rem] left-0 right-0 w-full p-4 bg-black bg-opacity-50 shadow-lg z-50">
            <div className="flex justify-center items-center space-x-2 relative">
              <div className="flex flex-wrap  w-full">

                <div className="grid grid-cols-[40%,53%] gap-2 mt-5 ms-[2.6%]">
                  {/* Style Section */}
                  <div className="inline-block">
                    

                    {/* Dynamic grid for layouts */}
                    {/* A tile is a third of the row, however many layouts there
                        are. Sizing the columns purely by the count meant one
                        layout — a distributor with a single one — stretched its
                        thumbnail across the whole panel. Fewer than three now
                        leave the remaining space empty instead. */}
                    <div
                      className="grid gap-3"
                      style={{
                        gridTemplateColumns: `repeat(${Math.max(filteredLayouts.length, LAYOUT_TILES_PER_ROW)}, minmax(0, 1fr))`,
                      }}
                    >
                      {filteredLayouts.map((layout) => (
                        <div
                          key={layout.key}
                          className={`p-1 text-center group cursor-pointer relative box-border ${layout.status !== "Active" ? "opacity-50 pointer-events-none" : ""
                            }`}
                          onClick={() =>
                            layout.status === "Active" &&
                            handleStyleChange({ name: layout.label, id: layout.key })
                          }
                        >
                          {layout.key === layoutKey && (
                            <span className="absolute top-2 right-2 z-10 w-[16px] h-[16px] rounded-full bg-green-500 text-white flex items-center justify-center text-[10px] font-bold leading-none">
                              ✓
                            </span>
                          )}
                          <img
                            src={`${process.env.REACT_APP_VISUAL_APP_IMAGE_BASE_URL || ""}${layout.image}`}
                            alt={layout.label}
                            className="w-full p-3 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300"
                          />
                          <p className="text-gray-800 bg-[#d7d7d7] text-[0.9rem] break-words whitespace-normal">
                            {layout.label}
                          </p>

                          {layout.status !== "Active" && (
                            <div className="absolute top-0 left-0 w-full h-full bg-gray-600 opacity-50 rounded-md"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Grain Section (invisible for now) */}
                  <div className="invisible">
                    <h3 className="text-md font-medium mb-1 bg-[#d7d7d7] p-0.5 text-center text-gray-800 uppercase mx-1">
                      Grain
                    </h3>
                    <div className="flex flex-wrap justify-between text-sm">
                      <div className='invisible'>
                        <h3 className="text-md font-medium mb-1 bg-[#d7d7d7] p-0.5 text-center text-gray-800 uppercase mx-1">
                          Grain
                        </h3>
                        <div className="flex flex-wrap justify-between text-sm">
                          <div className="p-1 text-center w-1/4 group cursor-pointer" onClick={() => handleGrainChange({ name: "Vertical", color: 'yellow' })}>
                            <img src={Grain1} alt="Vertical" className="w-full p-4 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300" />
                            <p className="text-gray-800 bg-[#d7d7d7] p-1">HORIZONTAL</p>
                          </div>
                          <div className="p-1 text-center w-1/4 group cursor-pointer" onClick={() => handleGrainChange({ name: "Horizontal", color: 'orange' })}>
                            <img src={Grain2} alt="Horizontal" className="w-full p-4 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300" />
                            <p className="text-gray-800 bg-[#d7d7d7] p-1">VERTICAL SEQUENCE</p>
                          </div>
                          <div className="p-1 text-center w-1/4 group cursor-pointer" onClick={() => handleGrainChange({ name: "Horizontal", color: 'orange' })}>
                            <img src={Grain3} alt="Horizontal" className="w-full p-4 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300" />
                            <p className="text-gray-800 bg-[#d7d7d7] uppercase p-1">Vertical</p>
                          </div>
                          <div className="p-1 text-center w-1/4 group cursor-pointer" onClick={() => handleGrainChange({ name: "Horizontal", color: 'orange' })}>
                            <img src={Grain4} alt="Horizontal" className="w-full p-4 h-auto mb-2 bg-white group-hover:bg-white transition-all duration-300" />
                            <p className="text-gray-800 bg-[#d7d7d7] uppercase p-1">Horizontal Sequence</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="absolute -top-[1rem] right-0 xl:-right- p-4">
              <button className="bg-black text-white px-[0.38rem] py-[0.05rem] w- rounded-full" onClick={closePopup}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

          </div>
        </div>
      )}

    </div>

  );
};

export default Nav; 
